// extracted by mini-css-extract-plugin
module.exports = {"CompanyCheckboxButton":"director_CompanyCheckboxButton__UXMu0","CheckboxButtonSimple":"director_CheckboxButtonSimple__1bQxR","ButtonCheckbox":"director_ButtonCheckbox__3hEmF"};